import { useParams } from "react-router";
import { useVbsOrderShowQuery } from "@/services/backend/vbs/orders/api/order-api";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import {
  OrderCard,
  OrderCardSkeleton,
} from "@/routes/processes/[processId]/vbs/orders/[orderId]/data/_components/order-card";

export function OrderDataRoute() {
  const { orderId } = useParams();

  const {
    data: order,
    isLoading,
    error,
  } = useVbsOrderShowQuery({
    id: orderId!,
  });

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (isLoading) {
    return <OrderCardSkeleton />;
  }

  return (
    <div className="grid gap-2">
      <OrderCard order={order!} />
    </div>
  );
}
